import { HashRouter, Route, Routes, Navigate } from "react-router-dom"
import { useIsAuthenticated } from "@azure/msal-react"
import Dashboard from "./pages/protected/Dashboard.jsx"
import Landing from "pages/public/Landing.jsx"
import { Toast, ToastContainer, Spinner } from "react-bootstrap"
import { useState, useEffect } from "react"
import axios from "axios"
import { AuthContextProvider } from "store/auth-context.js"
import * as Yup from 'yup'

Yup.addMethod(Yup.string, "csvInputCheck", function (errorMessage) {
    return this.test(`csv-input-check`, errorMessage, function (value) {
        const { path, createError } = this;
        return (
            value === undefined ||
            value === null ||
            value === "" ||
            (value.indexOf(',') === -1 && value.indexOf('"') === -1) ||
            createError({ path, message: errorMessage })
        );
    });
});

const App = () => {
    const [loading, setLoading] = useState(false)
    const [errorDialogs, setErrorDialogs] = useState({ items: [{visible: false, msg: ''}]})

    useEffect(() => {
        // start spinner on any request
        const reqId = axios.interceptors.request.use(cfg => {
            setLoading(true)
            return cfg
        })

    // Global error handling for axios
    const resId = axios.interceptors.response.use(function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        setLoading(false)
        return response
    }, function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        setLoading(false)
        let errorMessages = [];

        if (!error || !error.response) {
            errorMessages.push({ visible: true, msg: "Unknown error"});
        }
        else if (!error.response.data) { // If there's no response, it's a network/client failure
            errorMessages.push({ visible: true, msg: `Network Error: cannot reach ${error.config.url}` })
        }
        else if (error.response.data
            && error.response.data.title
            && error.response.data.errors
        ) {
            let structuredError = error.response.data;
            errorMessages.push({ visible: true, msg: structuredError.title });

            let fields = Object.keys(structuredError.errors);
            // the keys are a path to the form fields, meant to highlight the fields with errors, etc.
            fields.forEach(function (key) {
                let fieldErrors = { visible: true, msg: structuredError.errors[key][0] };
                errorMessages.push(fieldErrors);
            });
        }
        else if (error.config.url 
            && error.message) { // Matches coded messages like 404s, adds URL to message
            errorMessages.push({ visible: true, msg: `Network Error: ${error.message}: ${error.config.url}` })
        }
        else if (error.response.data && typeof error.response.data === 'string') {
            errorMessages.push({ visible: true, msg: error.response.data });
        }
        else if (error.response.status) {
            errorMessages.push({ visible: true, msg: error.response.status + " " + error.response.statusText });
        }
        else if (error.response.data && typeof error.response.data === 'object') {
            let keys = Object.keys({ visible: true, msg: error.response.data }); // get all own property names of the object

            keys.forEach(function (key) {
                let value = error.response.data[key]; // get property value

                // if the property value is an object...
                if (value && typeof value === 'object') {
                    errorMessages.push({ visible: true, msg: "   " + value[0] });
                }
            });
        }
        else { console.error(error); }

        let currentErrors = errorDialogs
        currentErrors.items = [...errorMessages]

        setErrorDialogs(currentErrors)

        return Promise.reject(error);
    })

        return () => {
            axios.interceptors.request.eject(reqId)
            axios.interceptors.response.eject(resId)
        }
    }, [])


    return (
        <>  
            {/* global spinner */}
            {loading && (
                <output className="spinner-overlay">
                    <Spinner animation="border" aria-hidden="true" />
                    <span className="visually-hidden">Loading…</span>
                </output>
            )}
            <HashRouter>
                <Routes>
                    <Route index element={<LandingNav />} />
                    <Route
                        path="dashboard/*"
                        element={
                            <ProtectedRoute isAuthenticated={useIsAuthenticated()}>
                                <AuthContextProvider>
                                    <Dashboard />
                                </AuthContextProvider>
                            </ProtectedRoute>
                        }
                    />
                    <Route path="*" element={<p>There's nothing here: 404!</p>} />
                </Routes>
            </HashRouter>

            <ToastContainer className="p-3 flex-column" position="bottom-center">
                {errorDialogs.items.map((thisToast, index) => {
                    return (
                        <Toast
                                key={index}
                                bg="danger"
                                onClose={() => setErrorDialogs(prev => ({
                                    items: prev.items.map((item, i) =>
                                        i === index ? { ...item, visible: false } : item
                                    )
                                }))}
                            show={thisToast.visible}
                        >
                            <Toast.Header>
                                <strong className="me-auto">Error</strong>
                            </Toast.Header>
                            <Toast.Body className="Danger text-white" style={{ whiteSpace: 'pre-line' }}>
                                {thisToast.msg}
                            </Toast.Body>
                        </Toast>
                    )
                })}
            </ToastContainer>
        </>
    )
}

const ProtectedRoute = ({ isAuthenticated, children }) => {
    return isAuthenticated ? children : <Navigate to="/" replace />
}

const LandingNav = () => {
    return useIsAuthenticated() ? <Navigate to="/dashboard" replace /> : <Landing />
}

export default App
